import Send from '@mui/icons-material/Send';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function SendIcon(props: FixMe) {
  return <Send {...props} />;
}

export default SendIcon;
